module.exports = __webpack_public_path__ + "static/media/mozilla-firefox-icon.ca44b2d4.png";